import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { idempotencyHeader } from 'Helpers/apiUtils';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

export default function CreateTagModal(props) {
    const close = () => {
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={props.tag?.id ? $t('Edit code') : $t('Add code')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.loading ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="modal__form-container">
                                <CreateTagFrom
                                    tagCategory={props.tagCategory}
                                    tag={props.tag}
                                    storeUrl={props.storeUrl}
                                    updateUrl={props.updateUrl}
                                    onCancel={close}
                                    onSuccess={() => {
                                        props.onSuccess();
                                        close();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

const ServiceSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    code: Yup.string().nullable(),
    description: Yup.string().nullable(),
    tag_category_id: Yup.string(),
});

function CreateTagFrom({ tagCategory, tag, storeUrl, updateUrl, onSuccess, onCancel }) {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: tag?.name || '',
                code: tag?.code || '',
                description: tag?.description || '',
                tag_category_id: tagCategory?.id || '',
            }}
            validationSchema={ServiceSchema}
            onSubmit={(values, actions) => {
                let url = tag?.id ? updateUrl.replace('TAG_ID', tag.id) : storeUrl;
                let method = tag?.id ? 'put' : 'post';

                axios({
                    method,
                    url,
                    data: values,
                    headers: tag?.id ? {} : { ...idempotencyHeader() },
                })
                    .then((res) => {
                        onSuccess();
                        actions.resetForm();
                    })
                    .catch((e) => {
                        e?.response?.data?.errors && actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ errors, touched, isSubmitting, handleSubmit }) => (
                <>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                        <TextFormField label={$t('Name')} type="text" name="name"></TextFormField>
                        <TextFormField label={$t('Code')} type="text" name="code"></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField label={$t('Description')} as="textarea" type="text" name="description"></TextareaFormField>
                    </div>

                    <p className="tw-text-sm tw-text-charcoal-50 tw-mt-1">
                        {$t('Source is set to')} <span className="tw-text-green tw-font-medium">{$t('Manual')}</span>{' '}
                        {$t('automatically. Manual codes are editable and deletable; synced codes are managed in their owning module.')}
                    </p>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={onCancel}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
